import { createFileRoute } from '@tanstack/react-router'
import { trpc } from '@/main'
import { noop } from '@tanstack/react-query'

// Pathless layout that OWNS the rail's search-keyed query, so a keystroke re-keys THIS match and not the section
// root above it. The root paints the section skeleton at `pendingMs: 0`, and a route at 0 that re-keys on `q` swaps
// its component for that skeleton on every debounced keystroke — unmounting the search box and dropping the list
// `useDeferredValue` was holding. With no pendingComponent here, the same re-key paints nothing (AGENTS.md, "give
// it a real layout route"). The rail in jobs.tsx reads this match with `useMatch({ from: '/_app/jobs/_list' })`.
export const Route = createFileRoute('/_app/jobs/_list')({
  loaderDeps: ({ search }) => ({ q: search.q }),
  // The rail list's key. `q` lives in the URL (the search box writes it), so the loader and the panel read the ONE
  // object built here — no unsearched-vs-searched pair to hold in sync. Puestos are always positions.
  context: ({ deps }) => ({
    jobsListInfiniteQueryOptions: trpc.jobs.listJobs.infiniteQueryOptions(
      { q: deps.q, isPosition: true },
      { getNextPageParam: (lastPage) => lastPage.nextCursor },
    ),
  }),
  loader: ({ context }) => {
    context.queryClient.infiniteQuery(context.jobsListInfiniteQueryOptions).catch(noop)
  },
})
